<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">Ombor Qoldig'i</h2>

        <div class="header-actions">

          <!-- Brend Filtr -->
          <div class="filter-select-container">
            <select v-model="filter.brand_id" class="status-select" @change="onBrandChange">
              <option :value="null">Barcha Brendlar</option>
              <option v-for="b in brandList" :key="b.id" :value="b.id">{{ b.name }}</option>
            </select>
          </div>

          <!-- Model Filtr -->
          <div class="filter-select-container">
            <select v-model="filter.model_id" class="status-select" @change="fetchProducts(true)">
              <option :value="null">Barcha Modellar</option>
              <option v-for="m in modelList" :key="m.id" :value="m.id">{{ m.name }}</option>
            </select>
          </div>

          <!-- Qidiruv -->
          <div class="search-container">
            <input type="text" v-model="filter.keyword" @input="onSearch" class="search-input"
              placeholder="Nomi bo'yicha qidirish...">
          </div>

          <Top />
        </div>
      </div>

      <!-- Papka yo'li (qidiruv/filtrda barcha papkalardan qidiriladi, shuning uchun yashiriladi) -->
      <div v-if="!isFiltering" class="folder-path">
        <a v-if="folderPath.length" href="#" @click.prevent="goToFolder(-1)">
          <b-icon icon="folder2-open"></b-icon> Barcha mahsulotlar
        </a>
        <span v-else class="fp-active"><b-icon icon="folder2-open"></b-icon> Barcha mahsulotlar</span>
        <template v-for="(f, i) in folderPath">
          <span :key="'s' + f.id" class="fp-sep">/</span>
          <a v-if="i < folderPath.length - 1" :key="f.id" href="#" @click.prevent="goToFolder(i)">{{ f.name }}</a>
          <span v-else :key="f.id" class="fp-active">{{ f.name }}</span>
        </template>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper" @scroll="handleScroll" ref="tableContainer">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 60px">№</th>
                <th>MAHSULOT NOMI</th>
                <th>BREND / MODEL</th>
                <th>NARX (SOTISH)</th>
                <th style="text-align: center;">QOLDIQ</th>
                <th style="width: 90px; text-align: center;">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <!-- Papkalar: 2 marta bosilsa ichiga kiradi -->
              <tr v-for="item in productlist.filter(x => isFolder(x))" :key="'f' + item.id"
                class="folder-row" title="Ochish uchun 2 marta bosing" @dblclick="openFolder(item)">
                <td><b-icon icon="folder-fill" class="folder-icon"></b-icon></td>
                <td colspan="5">
                  <div class="font-bold text-dark">{{ item.extra_name || item.name }}</div>
                  <div class="text-muted small">Papka — 2 marta bosing</div>
                </td>
              </tr>
              <tr v-for="item in productlist.filter(x => !isFolder(x))" :key="item.id">
                <!-- ID -->
                <td><span class="id-badge">{{ item.id }}</span></td>

                <!-- Mahsulot Nomi -->
                <td>
                  <div class="font-bold text-dark">{{ item.extra_name || item.name }}</div>
                  <div class="text-muted small" v-if="item.code">Kod: {{ item.code }}</div>
                </td>

                <!-- Brend va Model -->
                <td>
                  <div class="text-dark font-weight-bold">{{ item.brand_name }}</div>
                  <div class="text-muted small">{{ item.model_name}}</div>
                </td>

                <!-- Narx -->
                <td class="price blue">
                  {{ formatSumma(getProductPrice(item)) }} <small>so'm</small>
                </td>

                <!-- Qoldiq (Status o'rnida) -->
                <td style="text-align: center;">
                  <span class="tag" :class="item.balance > 0 ? 'green-tag' : 'red-tag'">
                    {{ item.balance || 0 }}
                  </span>
                </td>

                <!-- Reviziya -->
                <td style="text-align: center;">
                  <button type="button" class="rev-btn" @click="openRevision(item)" title="Reviziya — qoldiqni to'g'rilash">
                    <b-icon icon="clipboard-check"></b-icon>
                  </button>
                </td>

                </tr>

                <!-- BO'SH HOLAT -->
                <tr v-if="!loading && productlist.length === 0">
                  <td colspan="6" class="empty-row">
                    <div class="py-5 text-center">
                      <b-icon icon="box-seam" font-scale="3" class="mb-3 text-light"></b-icon>
                      <p class="text-muted">Omborda mahsulot topilmadi</p>
                    </div>
                  </td>
                </tr>

                <!-- LOADING -->
                <tr v-if="loading">
                  <td colspan="6" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Yuklanmoqda...</span>
                    </div>
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- TEZ REVIZIYA MODALI -->
    <div v-if="revModal.show" class="rev-overlay" @click.self="closeRevision">
      <div class="rev-modal">
        <div class="rev-head">
          <h3><b-icon icon="clipboard-check"></b-icon> Reviziya</h3>
          <button class="rev-close" @click="closeRevision">&times;</button>
        </div>
        <div class="rev-body">
          <div class="rev-prod">{{ revModal.name }}</div>
          <div class="rev-row">
            <span>Tizimdagi qoldiq:</span>
            <b :class="{ 'out-stock': revModal.currentBalance <= 0 }">{{ revModal.currentBalance }}</b>
          </div>
          <label class="rev-label">Ombordagi haqiqiy miqdor</label>
          <input ref="revInput" type="number" min="0" v-model.number="revModal.realCount"
            class="rev-input" @keyup.enter="saveRevision" />
          <p class="rev-hint">
            <b-icon icon="info-circle"></b-icon>
            Kiritilgandan so'ng qoldiq to'g'rilanadi va Reviziya tarixiga yoziladi.
          </p>
        </div>
        <div class="rev-actions">
          <button class="rev-cancel" @click="closeRevision">Bekor</button>
          <button class="rev-save" :disabled="revModal.saving" @click="saveRevision">
            {{ revModal.saving ? 'Saqlanmoqda...' : 'Saqlash' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';
import Top from '../Layout/Top.vue';

export default {
  name: 'OmborQoldiq',
  components: { Top },
  data() {
    return {
      loading: false,
      brandList: [],
      modelList: [],
      productlist: [],

      // Pagination uchun yangi o'zgaruvchilar
      page: 1,
      limit: 50, // Bir martada 50 ta yuklaymiz (tezroq ishlashi uchun)
      hasMore: true, // Yana ma'lumot bormi?

      filter: {
        brand_id: null,
        model_id: null,
        keyword: '',
      },
      // Papkalar bo'ylab navigatsiya: 0 = ildiz, folderPath = [{id, name}, ...]
      currentFolderId: 0,
      folderPath: [],
      // Tez reviziya modali
      revModal: {
        show: false, item: null, productId: null, name: '',
        currentBalance: 0, realCount: 0, saving: false,
      },
    };
  },
  mounted() {
    this.fetchBrands();
    this.fetchProducts(true); // true = ro'yxatni tozalab yangidan yuklash
  },
  computed: {
    // Qidiruv yoki brend/model filtri — backend papkadan qat'i nazar hamma joydan qidiradi
    isFiltering() {
      return !!((this.filter.keyword || '').trim() || this.filter.brand_id || this.filter.model_id);
    },
  },
  methods: {
    isFolder(item) {
      return Number(item.is_folder) === 1;
    },
    openFolder(folder) {
      this.folderPath.push({ id: folder.id, name: folder.extra_name || folder.name });
      this.currentFolderId = folder.id;
      this.fetchProducts(true);
    },
    // index = -1 — ildizga, aks holda folderPath[index] papkasiga qaytish
    goToFolder(index) {
      this.folderPath = this.folderPath.slice(0, index + 1);
      this.currentFolderId = index >= 0 ? this.folderPath[index].id : 0;
      this.fetchProducts(true);
    },
    formatSumma(s) {
      return Number(s || 0).toLocaleString().replace(/,/g, ' ');
    },
    getProductPrice(item) {
      return item.price_register ? item.price_register.chakana_price : 0;
    },

    async fetchBrands() {
      try {
        const res = await axios.get('api/v1/brand/');
        this.brandList = res.data;
      } catch (e) { console.error(e); }
    },

    async onBrandChange() {
      this.filter.model_id = null;
      if (this.filter.brand_id) {
        try {
          const res = await axios.get(`api/v1/model/?brand_id=${this.filter.brand_id}`);
          this.modelList = res.data;
        } catch (e) { this.modelList = []; }
      } else {
        this.modelList = [];
      }
      this.fetchProducts(true); // Brend o'zgarsa yangidan yuklaymiz
    },

    // Qidiruv va Model o'zgarganda
    onFilterChange() {
      this.fetchProducts(true);
    },

    onSearch: debounce(function () {
      this.fetchProducts(true);
    }, 500),

    // Scroll hodisasi
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      // Agar pastga yetib qolsa (50px qolganda) va hozir yuklanmayotgan bo'lsa
      if (scrollHeight - scrollTop <= clientHeight + 50 && !this.loading && this.hasMore) {
        this.page += 1;
        this.fetchProducts(false); // false = davomiga qo'shish
      }
    },

    /**
     * @param {boolean} reset - Agar true bo'lsa ro'yxatni tozalaydi (yangi qidiruv), false bo'lsa davomiga qo'shadi
     */
    async fetchProducts(reset = false) {
      if (reset) {
        this.page = 1;
        this.hasMore = true;
        this.productlist = [];
        // Scrollni tepaga qaytarish
        if (this.$refs.tableContainer) this.$refs.tableContainer.scrollTop = 0;
      }

      // Agar data tugagan bo'lsa so'rov yuborma
      if (!this.hasMore && !reset) return;

      this.loading = true;
      try {
        const skladId = localStorage.getItem('sklad_id');

        const res = await axios.post(`api/v1/product/all-price-balance/${this.currentFolderId}`, {
          sklad_id: Number(skladId),
          keyword: this.filter.keyword,
          model_id: this.filter.model_id,
          brand_id: this.filter.brand_id,
          limit: this.limit,
          page: this.page,
        });

        const newData = res.data;

        if (reset) {
          this.productlist = newData;
        } else {
          // Eski ro'yxatga yangisini qo'shamiz
          this.productlist = [...this.productlist, ...newData];
        }

        // Agar kelgan ma'lumot limitdan kam bo'lsa, demak boshqa ma'lumot yo'q
        if (newData.length < this.limit) {
          this.hasMore = false;
        }

      } catch (e) {
        console.error(e);
        if (reset) this.productlist = [];
      } finally {
        this.loading = false;
      }
    },

    // ============== TEZ REVIZIYA (qoldiqni qo'lda to'g'rilash) ==============
    openRevision(item) {
      this.revModal = {
        show: true,
        item,
        productId: item.id,
        name: item.extra_name || item.name || '',
        currentBalance: Number(item.balance || 0),
        realCount: Number(item.balance || 0),
        saving: false,
      };
      this.$nextTick(() => {
        if (this.$refs.revInput) { this.$refs.revInput.focus(); this.$refs.revInput.select(); }
      });
    },
    closeRevision() {
      this.revModal.show = false;
    },
    async saveRevision() {
      if (this.revModal.saving) return;
      const realCount = Number(this.revModal.realCount);
      if (isNaN(realCount) || realCount < 0) {
        alert("To'g'ri miqdor kiriting");
        return;
      }
      this.revModal.saving = true;
      try {
        const sklad_id = Number(localStorage.getItem('sklad_id'));
        let count = this.revModal.currentBalance;
        let body_price = 0;
        try {
          const pb = await axios.post('api/v1/product/price-balance', {
            product_id: this.revModal.productId, sklad_id,
          });
          count = Number(pb.data.balance || 0);
          body_price = Number(pb.data.delivery_price || 0);
        } catch (e) { /* mavjud qiymatlar bilan davom */ }

        await axios.post('api/v1/revision/quick', {
          product_id: this.revModal.productId,
          real_count: realCount,
          count,
          body_price,
          sklad_id,
        });

        // Ro'yxatdagi qoldiqni darhol yangilaymiz
        if (this.revModal.item) this.revModal.item.balance = realCount;
        this.closeRevision();
      } catch (e) {
        alert("Reviziyada xatolik: " + (e.response?.data?.message || e.response?.data || "Serverda xato"));
      } finally {
        this.revModal.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.folder-path {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
}
.folder-path a { color: #7c3aed; text-decoration: none; }
.folder-path a:hover { text-decoration: underline; }
.fp-sep { color: #94a3b8; }
.fp-active { color: #334155; }
.folder-row { cursor: pointer; user-select: none; background: #fffbeb; }
.folder-row:hover { background: #fef3c7; }
.folder-icon { font-size: 20px; color: #f59e0b; }
/* ASOSIY CONTAINER */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  flex-wrap: wrap;
  gap: 15px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

/* INPUT VA SELECTLAR */
.status-select,
.search-input {
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 15px;
  font-weight: 600;
  color: #475569;
  outline: none;
  background: white;
  transition: all 0.2s;
  font-size: 14px;
}

.status-select {
  cursor: pointer;
  min-width: 150px;
}

.search-input {
  min-width: 200px;
}

.status-select:focus,
.search-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

/* JADVAL CARD */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

/* JADVAL STYLES */
.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
}

.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: 700;
  color: #64748b;
  font-size: 12px;
}

.price.blue {
  color: #2563eb;
  font-weight: 800;
  font-size: 15px;
}

/* TAGLAR (QOLDIQ UCHUN) */
.tag {
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  display: inline-block;
}

.tag.green-tag {
  background: #ecfdf5;
  color: #10b981;
}

.tag.red-tag {
  background: #fee2e2;
  color: #ef4444;
}

/* SCROLLBAR */
.table-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

/* REVIZIYA TUGMASI */
.rev-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  background: #eef2ff;
  color: #4f46e5;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.rev-btn:hover { background: #4f46e5; color: #fff; transform: scale(1.08); }

/* TEZ REVIZIYA MODALI */
.rev-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.rev-modal {
  background: #fff;
  width: 380px;
  max-width: 92vw;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: rev-pop 0.2s ease-out;
}
@keyframes rev-pop {
  from { transform: scale(0.94); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.rev-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #f1f5f9;
}
.rev-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.rev-close {
  border: none;
  background: #f1f5f9;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  font-size: 20px;
  color: #64748b;
  cursor: pointer;
}
.rev-close:hover { background: #e2e8f0; }
.rev-body { padding: 16px 18px; }
.rev-prod {
  font-weight: 700;
  font-size: 15px;
  color: #1e293b;
  margin-bottom: 10px;
}
.rev-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 12px;
}
.rev-row b { color: #0f172a; }
.rev-row b.out-stock { color: #ef4444; }
.rev-label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 5px;
}
.rev-input {
  width: 100%;
  height: 44px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 18px;
  font-weight: 800;
  text-align: center;
  outline: none;
}
.rev-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.12);
}
.rev-hint {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 11px;
  color: #94a3b8;
  margin: 10px 0 0;
}
.rev-actions {
  display: flex;
  gap: 10px;
  padding: 0 18px 18px;
}
.rev-cancel, .rev-save {
  flex: 1;
  height: 42px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  border: none;
}
.rev-cancel { background: #f1f5f9; color: #64748b; }
.rev-cancel:hover { background: #e2e8f0; }
.rev-save { background: #10b981; color: #fff; }
.rev-save:hover:not(:disabled) { background: #059669; }
.rev-save:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
